const $inject = [
  "$uibModalInstance",
  "hmr",
];

class HmrSupportingFilesModalController {
  constructor(
    $uibModalInstance,
    hmr
  ) {
    this.$uibModalInstance = $uibModalInstance;
    this.hmr = hmr;
  }

  dismiss() {
    this.$uibModalInstance.dismiss("cancel");
  }
}

HmrSupportingFilesModalController.$inject = $inject;

export default HmrSupportingFilesModalController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/controllers/modals/supporting-files.controller.js
 **/